import { BookingStatus } from 'shared/enums';

export const WAITING_FOR_STATUSES = [BookingStatus.NEW, BookingStatus.CONFLICT];
export const ALLOW_FOR_STATUSES = [BookingStatus.NEW, BookingStatus.LOCKED];

export const enum ScreenActiveEnum {
  BOOKING_BILL = 'BOOKING_BILL',
}
